export default function SvgIcons() {
  return (
    <>
      {/* empty-data */}
      <svg className="hidden">
        <svg
          id="empty-data"
          className="w-32 h-32 max-sm:w-24 max-sm:h-24"
          viewBox="0 0 150 150"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.4"
            d="M101.5 22.8126H48.5002C33.0627 22.8126 20.5627 35.3751 20.5627 50.7501V109.563C20.5627 124.938 33.1252 137.5 48.5002 137.5H101.438C116.875 137.5 129.375 124.938 129.375 109.563V50.7501C129.438 35.3126 116.875 22.8126 101.5 22.8126Z"
            fill="#63646B"
          />
          <path
            d="M89.6875 12.5H60.3125C53.8125 12.5 48.5 17.75 48.5 24.25V30.125C48.5 36.625 53.75 41.875 60.25 41.875H89.6875C96.1875 41.875 101.437 36.625 101.437 30.125V24.25C101.5 17.75 96.1875 12.5 89.6875 12.5Z"
            fill="#63646B"
          />
          <path
            d="M90.812 97.625L81.7495 88.5625L90.4995 79.8125C92.312 78 92.312 75 90.4995 73.1875C88.687 71.375 85.687 71.375 83.8745 73.1875L75.1245 81.9375L66.062 72.875C64.2495 71.0625 61.2495 71.0625 59.437 72.875C57.6245 74.6875 57.6245 77.6875 59.437 79.5L68.4995 88.5625L59.187 97.875C57.3745 99.6875 57.3745 102.687 59.187 104.5C60.1245 105.437 61.312 105.875 62.4995 105.875C63.687 105.875 64.8745 105.437 65.812 104.5L75.1245 95.1875L84.187 104.25C85.1245 105.188 86.312 105.625 87.4995 105.625C88.687 105.625 89.8745 105.188 90.812 104.25C92.6245 102.438 92.6245 99.5 90.812 97.625Z"
            fill="#63646B"
          />
        </svg>
      </svg>
      {/* plus ✅ */}
      <svg className="hidden">
        <symbol id="plus" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.6001 9.95H14.4001"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 15.35V4.55"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </symbol>
      </svg>
      {/* view ✅ */}
      <svg className="hidden">
        <symbol id="view" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.5799 12.5C15.5799 14.48 13.9799 16.08 11.9999 16.08C10.0199 16.08 8.41992 14.48 8.41992 12.5C8.41992 10.52 10.0199 8.92004 11.9999 8.92004C13.9799 8.92004 15.5799 10.52 15.5799 12.5Z"
            stroke="#616161"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.9998 20.77C15.5298 20.77 18.8198 18.69 21.1098 15.09C22.0098 13.68 22.0098 11.31 21.1098 9.89997C18.8198 6.29997 15.5298 4.21997 11.9998 4.21997C8.46984 4.21997 5.17984 6.29997 2.88984 9.89997C1.98984 11.31 1.98984 13.68 2.88984 15.09C5.17984 18.69 8.46984 20.77 11.9998 20.77Z"
            stroke="#616161"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </symbol>
      </svg>
      {/* calendar ✅ */}
      <svg className="hidden">
        <svg id="calendar" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8 2.49976V5.49976"
            stroke="#616161"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16 2.49976V5.49976"
            stroke="#616161"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.5 9.58984H20.5"
            stroke="#616161"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 9V17.5C21 20.5 19.5 22.5 16 22.5H8C4.5 22.5 3 20.5 3 17.5V9C3 6 4.5 4 8 4H16C19.5 4 21 6 21 9Z"
            stroke="#616161"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.996 14.2005H12.005"
            stroke="#616161"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.29482 14.2005H8.30381"
            stroke="#616161"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.29482 17.2005H8.30381"
            stroke="#616161"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </svg>
      {/* map ✅ */}
      <svg className="hidden">
        <symbol id="map" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.0004 14.1912C13.4363 14.1912 14.6004 13.0272 14.6004 11.5912C14.6004 10.1553 13.4363 8.99121 12.0004 8.99121C10.5645 8.99121 9.40039 10.1553 9.40039 11.5912C9.40039 13.0272 10.5645 14.1912 12.0004 14.1912Z"
            stroke="#616161"
          />
          <path
            d="M5.01577 10.0745C6.65744 2.85781 17.3491 2.86614 18.9824 10.0828C19.9408 14.3161 17.3074 17.8995 14.9991 20.1161C13.3241 21.7328 10.6741 21.7328 8.99077 20.1161C6.69077 17.8995 4.05744 14.3078 5.01577 10.0745Z"
            stroke="#616161"
          />
        </symbol>
      </svg>
      {/* search ✅ */}
      <svg className="hidden">
        <symbol id="search" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
            stroke="#0C0C0C"
            strokeOpacity="0.5"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22 22L20 20"
            stroke="#0C0C0C"
            strokeOpacity="0.5"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </symbol>
      </svg>
      {/* filter ✅ */}
      <svg className="hidden">
        <symbol id="filter" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M22 6.5H16"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 6.5H2"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 10C11.933 10 13.5 8.433 13.5 6.5C13.5 4.567 11.933 3 10 3C8.067 3 6.5 4.567 6.5 6.5C6.5 8.433 8.067 10 10 10Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22 17.5H18"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 17.5H2"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14 21C15.933 21 17.5 19.433 17.5 17.5C17.5 15.567 15.933 14 14 14C12.067 14 10.5 15.567 10.5 17.5C10.5 19.433 12.067 21 14 21Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </symbol>
      </svg>
      {/* group-management ✅ */}
      <svg className="hidden">
        <symbol
          id="group-management"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 11H4M20 11C21.1046 11 22 11.8954 22 13V17C22 19.2091 20.2091 21 18 21H6C3.79086 21 2 19.2091 2 17V13C2 11.8954 2.89543 11 4 11M20 11V9C20 7.89543 19.1046 7 18 7M4 11V9C4 7.89543 4.89543 7 6 7M18 7H6M18 7V5C18 3.89543 17.1046 3 16 3H8C6.89543 3 6 3.89543 6 5V7M10 14H14"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </symbol>
      </svg>
      {/* trash ✅ */}
      <svg className="hidden">
        <symbol id="trash" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21 6.48001C17.67 6.15001 14.32 5.98001 10.98 5.98001C9 5.98001 7.02 6.08001 5.04 6.28001L3 6.48001"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.5 5.47L8.72 4.16C8.88 3.21 9 2.5 10.69 2.5H13.31C15 2.5 15.13 3.25 15.28 4.17L15.5 5.47"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.8484 9.64001L18.1984 19.71C18.0884 21.28 17.9984 22.5 15.2084 22.5H8.78844C5.99844 22.5 5.90844 21.28 5.79844 19.71L5.14844 9.64001"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.3301 17H13.6601"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M9.5 13H14.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </symbol>
      </svg>
      {/* share ✅ */}
      <svg className="hidden">
        <symbol id="share" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.13118 10.9344C8.55656 9.7874 7.37023 9 6 9C4.067 9 2.5 10.567 2.5 12.5C2.5 14.433 4.067 16 6 16C7.37023 16 8.55656 15.2126 9.13118 14.0656M9.13118 10.9344C9.36718 11.4055 9.5 11.9372 9.5 12.5C9.5 13.0628 9.36718 13.5945 9.13118 14.0656M9.13118 10.9344L15.8688 7.56559M9.13118 14.0656L15.8688 17.4344M15.8688 7.56559C16.4434 8.7126 17.6298 9.5 19 9.5C20.933 9.5 22.5 7.933 22.5 6C22.5 4.067 20.933 2.5 19 2.5C17.067 2.5 15.5 4.067 15.5 6C15.5 6.56276 15.6328 7.09451 15.8688 7.56559ZM15.8688 17.4344C15.6328 17.9055 15.5 18.4372 15.5 19C15.5 20.933 17.067 22.5 19 22.5C20.933 22.5 22.5 20.933 22.5 19C22.5 17.067 20.933 15.5 19 15.5C17.6298 15.5 16.4434 16.2874 15.8688 17.4344Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </symbol>
      </svg>
      {/* edit ✅ */}
      <svg className="hidden">
        <symbol id="edit" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.2594 4.1L5.04936 12.79C4.73936 13.12 4.43936 13.77 4.37936 14.22L4.00936 17.46C3.87936 18.63 4.71936 19.43 5.87936 19.23L9.09936 18.68C9.54936 18.6 10.1794 18.27 10.4894 17.93L18.6994 9.24C20.1194 7.74 20.7594 6.03 18.5494 3.94C16.3494 1.87 14.6794 2.6 13.2594 4.1Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.8906 5.54999C12.3206 8.30999 14.5606 10.42 17.3406 10.7"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3 22.5H21"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </symbol>
      </svg>
      {/* close ✅ */}
      <svg className="hidden">
        <symbol id="close" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
            fill="#242424"
          />
        </symbol>
      </svg>
      {/* note ✅ */}
      <svg className="hidden">
        <symbol id="note" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21 10.5V8C21 5.79086 19.2091 4 17 4H7C4.79086 4 3 5.79086 3 8V18.5C3 20.7091 4.79086 22.5 7 22.5H9M8 2.5V5.5M16 9.5H8M14 13.5H8M10 17.5H8M16 2.5V5.5M12 22.5L15.0608 21.6274C15.2249 21.5806 15.3743 21.4928 15.495 21.3721L20.5098 16.3573C21.1634 15.7037 21.1634 14.6439 20.5098 13.9902C19.8561 13.3366 18.7963 13.3366 18.1427 13.9902L13.1279 19.005C13.0072 19.1257 12.9194 19.2751 12.8726 19.4392L12 22.5Z"
            stroke="#616161"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </symbol>
      </svg>
      {/* sort ✅ */}
      <svg className="hidden">
        <symbol id="sort" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 7H21" stroke="#242424" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M6 12H18" stroke="#242424" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M10 17H14" stroke="#242424" strokeWidth="1.5" strokeLinecap="round" />
        </symbol>
      </svg>
      {/* call */}
      <svg className="hidden">
        <symbol id="call" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.97 18.83C21.97 19.19 21.89 19.56 21.72 19.92C21.55 20.28 21.33 20.62 21.04 20.94C20.55 21.48 20.01 21.87 19.4 22.12C18.8 22.37 18.15 22.5 17.45 22.5C16.43 22.5 15.34 22.26 14.19 21.77C13.04 21.28 11.89 20.62 10.75 19.79C9.6 18.95 8.51 18.02 7.47 16.99C6.44 15.95 5.51 14.86 4.68 13.72C3.86 12.58 3.2 11.44 2.72 10.31C2.24 9.17 2 8.08 2 7.04C2 6.36 2.12 5.71 2.36 5.11C2.6 4.5 2.98 3.94 3.51 3.44C4.15 2.81 4.85 2.5 5.59 2.5C5.87 2.5 6.15 2.56 6.4 2.68C6.66 2.8 6.89 2.98 7.07 3.24L9.39 6.51C9.57 6.76 9.7 6.99 9.79 7.21C9.88 7.42 9.93 7.63 9.93 7.82C9.93 8.06 9.86 8.3 9.72 8.53C9.59 8.76 9.4 9 9.16 9.24L8.4 10.03C8.29 10.14 8.24 10.27 8.24 10.43C8.24 10.51 8.25 10.58 8.27 10.66C8.3 10.74 8.33 10.8 8.35 10.86C8.53 11.19 8.84 11.62 9.28 12.14C9.73 12.66 10.21 13.19 10.73 13.72C11.27 14.25 11.79 14.74 12.32 15.19C12.84 15.63 13.27 15.93 13.61 16.11C13.66 16.13 13.72 16.16 13.79 16.19C13.87 16.22 13.95 16.23 14.04 16.23C14.21 16.23 14.34 16.17 14.45 16.06L15.21 15.31C15.46 15.06 15.7 14.87 15.93 14.75C16.16 14.61 16.39 14.54 16.64 14.54C16.83 14.54 17.03 14.58 17.25 14.67C17.47 14.76 17.7 14.89 17.95 15.06L21.26 17.41C21.52 17.59 21.7 17.8 21.81 18.05C21.91 18.3 21.97 18.55 21.97 18.83Z"
            stroke="#616161"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            d="M18.5 9.5C18.5 8.9 18.03 7.98 17.33 7.23C16.69 6.54 15.84 6 15 6"
            stroke="#616161"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22 9.5C22 5.63 18.87 2.5 15 2.5"
            stroke="#616161"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </symbol>
      </svg>
    </>
  );
}
